module.exports = __webpack_public_path__ + "static/media/Files_Logo.0c7c1eb9.svg";